import t from "utils/translate";

type FoodNoiseContent = {
  header: string;
  headerInterpolations: {
    sum: number;
    score: number;
    higherLower: "higher" | "lower";
    gender: string;
  };
  text: string;
  chart: string;
  disclaimer: string;
  cta?: string;
  header2?: string;
  items?:{
    image: string;
    text: string;
    cta: string;
    link: string;
  }[];
};

export const foodNoiseContent = ({ 
  sum, 
  score, 
  gender, 
  chart,
}: {
  sum: number;
  score: number;
  gender: string;
  chart: string;
}): {
  higher: FoodNoiseContent;
  lower: FoodNoiseContent;
  higherActive: FoodNoiseContent;
  lowerActive: FoodNoiseContent;
} => ({
  higher: {
    header: t("FOOD_NOISE_RESULTS_HEADER"),
    headerInterpolations: {
      sum,
      score,
      higherLower: "higher",
      gender
    },
    text: t("FOOD_NOISE_RESULTS_TEXT_HIGHER"),
    chart,
    disclaimer: t("FOOD_NOISE_RESULTS_CHART_LEGAL"),
    cta: t("FOOD_NOISE_RESULTS_CTA"),
    header2: t("FOOD_NOISE_RESULTS_HEADER_2"),
    items: [
      {
        image: t("FOOD_NOISE_RESULTS_IMG_1_HIGHER"),
        text: t("FOOD_NOISE_RESULTS_ITEM_1_HIGHER"),
        cta: t("FOOD_NOISE_RESULTS_CTA_1_HIGHER"),
        link: t("FOOD_NOISE_RESULTS_CTA_LINK_1_HIGHER")
      },
      {
        image: t("FOOD_NOISE_RESULTS_IMG_2_HIGHER"),
        text: t("FOOD_NOISE_RESULTS_ITEM_2_HIGHER"),
        cta: t("FOOD_NOISE_RESULTS_CTA_2_HIGHER"),
        link: t("FOOD_NOISE_RESULTS_CTA_LINK_2_HIGHER")
      },
      {
        image: t("FOOD_NOISE_RESULTS_IMG_3_HIGHER"),
        text: t("FOOD_NOISE_RESULTS_ITEM_3_HIGHER"),
        cta: t("FOOD_NOISE_RESULTS_CTA_3_HIGHER"),
        link: t("FOOD_NOISE_RESULTS_CTA_LINK_3_HIGHER")
      }
    ]
  },
  lower: {
    header: t("FOOD_NOISE_RESULTS_HEADER"),
    headerInterpolations: {
      sum,
      score: 100 - score,
      higherLower: "lower",
      gender
    },
    text: t("FOOD_NOISE_RESULTS_TEXT_LOWER"),
    chart,
    disclaimer: t("FOOD_NOISE_RESULTS_CHART_LEGAL"),
    cta: t("FOOD_NOISE_RESULTS_CTA"),
    header2: t("FOOD_NOISE_RESULTS_HEADER_2"),
    items: [
      {
        image: t("FOOD_NOISE_RESULTS_IMG_1_LOWER"),
        text: t("FOOD_NOISE_RESULTS_ITEM_1_LOWER"),
        cta: t("FOOD_NOISE_RESULTS_CTA_1_LOWER"),
        link: t("FOOD_NOISE_RESULTS_CTA_LINK_1_LOWER")
      },
      {
        image: t("FOOD_NOISE_RESULTS_IMG_2_LOWER"),
        text: t("FOOD_NOISE_RESULTS_ITEM_2_LOWER"),
        cta: t("FOOD_NOISE_RESULTS_CTA_2_LOWER"),
        link: t("FOOD_NOISE_RESULTS_CTA_LINK_2_LOWER")
      },
      {
        image: t("FOOD_NOISE_RESULTS_IMG_3_LOWER"),
        text: t("FOOD_NOISE_RESULTS_ITEM_3_LOWER"),
        cta: t("FOOD_NOISE_RESULTS_CTA_3_LOWER"),
        link: t("FOOD_NOISE_RESULTS_CTA_LINK_3_LOWER")
      }
    ]
  },
  higherActive: {
    header: t("FOOD_NOISE_RESULTS_HEADER"),
    headerInterpolations: {
      sum,
      score,
      higherLower: "higher",
      gender
    },
    text: t("FOOD_NOISE_RESULTS_TEXT_ACTIVE_HIGHER"),
    chart,
    disclaimer: t("FOOD_NOISE_RESULTS_CHART_LEGAL"),
  },
  lowerActive: {
    header: t("FOOD_NOISE_RESULTS_HEADER"),
    headerInterpolations: {
      sum,
      score: 100 - score,
      higherLower: "lower",
      gender
    },
    text: t("FOOD_NOISE_RESULTS_TEXT_ACTIVE_LOWER"),
    chart,
    disclaimer: t("FOOD_NOISE_RESULTS_CHART_LEGAL"),
  },
});
